import { defaultReducer } from 'app/store/defaultReducer';
import { createReducerTool, createStateTool } from 'app/store/withDevTools';
import { FornecedorTypes } from './fornecedorAction';

export const initState = createStateTool({
  registro: undefined,
  visualizar: false,
  cadastrar: false,
  abrirImportModal: false,
  errorData: [],
  fileImport: '',
  page: { content: [] },
  requestParams: {
    page: 0,
    size: 15,
    q: undefined,
    sort: 'pessoa.nome,asc',
    totalCount: undefined,
  },
  selection: [],
  message: undefined,
  search: undefined,
  selecionados: [],
  carregandoRegistro: false,
  carregandoRegistros: false,
  tipoSelecao: 'NENHUM', // NENHUM, TODOS_PAGINA, TODOS_FILTRO
  filtroAvancado: {
    nome: undefined,
    razaoSocial: undefined,
    cpfCnpj: undefined,
    uf: undefined,
    email: undefined,
    cidade: undefined,
  },
});

function reducer(state, action, types) {
  if (action.type === FornecedorTypes.SET_FILTRO_AVANCADO) {
    return {
      ...state,
      filtroAvancado: action.payload,
    };
  }

  if (action.type === FornecedorTypes.FECHAR_MODAL) {
    return {
      ...state,
      buscaAvancada: false,
      cadastrar: false,
      visualizar: false,
    };
  }

  if (action.type === FornecedorTypes.FORNECEDOR_CLOSE_DIALOG) {
    return {
      ...state,
      cadastrar: false,
      visualizar: false,
    };
  }

  if (action.type === FornecedorTypes.ERRO_DATA) {
    return {
      ...state,
      errorData: action.payload,
    };
  }

  if (action.type === FornecedorTypes.SET_FILE_IMPORT) {
    return {
      ...state,
      fileImport: action.payload,
    };
  }

  if (action.type === FornecedorTypes.SHOW_MESSAGE) {
    return {
      ...state,
      message: action.payload,
    };
  }

  return defaultReducer(state, action, types);
}

export const fornecedorReducer = createReducerTool(reducer, FornecedorTypes);
